<div class="entity-onboard-wrapper">
  <div class="d-flex justify-space-between">
    <div class="exp-header">Export</div>
    <div (click)="onFormActionClick('no')" class="cursor">X</div>
  </div>
  <div class="exp-content">Are you sure you want to download {{data?.fileType === 'csv'? 'excel' : 'JSON'}}?</div>
  <div class="eo-action-list -end">
    <app-button [label]="'No'" [color]="buttonColor" (clicked)="onFormActionClick('no')">
    </app-button>
    <app-button [label]="'Yes'" (clicked)="onFormActionClick( 'yes')">
    </app-button>
  </div>
</div>
